<div class="details-item-label" [class.primary]="isPrimary">
  @if (!showLabel) {
    <div class="loading-placeholder" [class.dark-bg]="isDarkBg"></div>
  }
  @if (showLabel) {
    {{ label }}
  }
</div>

<div class="details-item-value" [class.multiline]="multiline">
  @if (!multiline) {
    <div class="loading-placeholder" [class.dark-bg]="isDarkBg"></div>
  }

  @if (multiline) {
    <div class="loading-wrapper">
      @for (row of [1, 2, 3]; track row) {
        <div class="loading-placeholder" [class.dark-bg]="isDarkBg"></div>
      }
    </div>
  }
</div>
